var exports = {
  "m": "Octicon__OTU_c2",
};

module.exports = exports;
